import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'
import type { Severity } from '@/lib/types'

const severityVariants = cva(
  'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold capitalize',
  {
    variants: {
      severity: {
        critical: 'bg-severity-critical text-white',
        high: 'bg-severity-high text-white',
        medium: 'bg-severity-medium text-white',
        low: 'bg-severity-low text-white',
        info: 'bg-severity-info text-white',
      },
    },
    defaultVariants: { severity: 'medium' },
  },
)

export interface SeverityBadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof severityVariants> {
  severity: Severity | 'info'
}

export function SeverityBadge({ severity, className, ...rest }: SeverityBadgeProps) {
  return (
    <span
      role="status"
      aria-label={`Severity: ${severity}`}
      className={cn(severityVariants({ severity }), className)}
      {...rest}
    >
      {severity}
    </span>
  )
}
